// extracted by mini-css-extract-plugin
export default {"section":"partnerSites-module--section--1RLV5","image":"partnerSites-module--image--1OIEi","section2":"partnerSites-module--section2--1W1rG"};